var map = {
	"./Dynafios1.webp": 813,
	"./FoodDining1.webp": 437,
	"./HDFC_App2.webp": 830,
	"./JohnHancock1.jpg": 758,
	"./Juno1.png": 992,
	"./WhiteHat_Jr1.webp": 33,
	"./airCrews1.png": 60,
	"./portfolio_screenshot.jpg": 288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;